import axios from 'axios'
const baseURL = process.env.REACT_APP_BASEURL
const HOST = process.env.NODE_ENV === 'production' ? baseURL : 'http://localhost:4000'
const phone = process.env.REACT_APP_PHONE
const password = process.env.REACT_APP_PASS
const currentTime = new Date
const timestamp = currentTime.getTime()
let cookieToken = ""

export const getSearchSuggestions = async ( query ) => {
  const response = await fetch( `${HOST}/search/suggest?keywords=${query}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getSearch = async ( query ) => {
  const response = await fetch( `${HOST}/search?keywords=${query}&offset=0&limit=50`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getSongDetailsById = async ( ids ) => {
  const response = await fetch( `${HOST}/song/detail?ids=${ids}`, { withCredentials: "include" } )
  const result = await response.json()
  return result.songs
}
// get "playback-url"
export const getSongURL = async ( id ) => {
  const response = await fetch( `${HOST}/song/url?id=${id}`, { withCredentials: "include" } )
  const result = await response.json()
  return result.data[0]
}
export const getSonglistURL = async ( ids ) => {
  const response = await fetch( `${HOST}/song/url?id=${ids}`, { withCredentials: "include" } )
  const result = await response.json()
  return result.data
}
export const getArtistById = async ( id ) => {
  const response = await fetch( `${HOST}/artists?id=${id}`, { withCredentials: "include" } )
  const result = await response.json()
  // console.log( "arist--api", result )
  return result
}
export const getAllSongsByArtist = async ( id ) => {
  const response = await fetch( `${HOST}/artist/songs?id=${id}&offset=0&&limit=60&order=hot`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getAlbumsByArtistId = async ( id, PAGE_SIZE ) => {
  const response = await fetch( `${HOST}/artist/album?id=${id}&offset=0&limit=${PAGE_SIZE}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getAlbumById = async ( id ) => {
  const response = await fetch( `${HOST}/album?id=${id}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const fetchSimilarSongs = async ( id ) => {
  const response = await fetch( `${HOST}/simi/song?id=${id}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getSimilarPlaylists = async ( songId ) => {
  const response = await fetch( `${HOST}/simi/playlist?id=${songId}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getLatestSongsEU = async () => {
  const response = await fetch( `${HOST}/top/song?type=96`, { withCredentials: "include" } )
  const result = await response.json()
  // console.log( result, "api--getLatestSongsEU" )
  return result.data
}

// Charts/TopLists
export const getTopList = async () => {
  const response = await fetch( `${HOST}/toplist`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const USBillboardList = async () => {
  const response = await fetch( `${HOST}/playlist/detail?id=3812895`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const UKBillboardList = async () => {
  const response = await fetch( `${HOST}/playlist/detail?id=180106`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
// Chartslists/TopLists End //
export const getPlayListDetails = async ( id ) => {
  const response = await fetch( `${HOST}/playlist/detail?id=${id}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
// BoutiquePlaylists
export const getCategoyTags = async ( cat ) => {
  cat = "电子"
  // 电子 electronic
  // 欧美 EU/US
  const response = await fetch( `${HOST}/playlist/highquality/tags?cat=${cat}`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getCatList = async () => {
  const response = await fetch( `${HOST}/playlist/catlist`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getTopListByCat = async ( { cat, order } ) => {
  const response = await fetch( `${HOST}/top/playlist?cat=${cat}&order=${order}&offset=0&limit=10`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const getHotPlaylists = async () => {
  const response = await fetch( `${HOST}/playlist/hot`, { withCredentials: "include" } )
  const result = await response.json()
  return result
}
export const fetchUserPlaylist = async ( uid ) => {
  const response = await fetch( `${HOST}/user/playlist?uid=${uid}&offset=0&limit=20`, { withCredentials: "include" } )
  const result = await response.json()
  // console.log( result, "user playlist" )
  return result
}
export const getLatestAlbums = async () => {
  //?area=EA&limit=10
  const response = await fetch( `${HOST}/album/new`, { withCredentials: "include" } )
  const result = await response.json()
  // console.log( result, "latest al" )

  return result
}
export const getTopArtist = async ( type ) => {
  const response = await fetch( `${HOST}/toplist/artist?type=${type}`, { withCredentials: "include" } )
  const result = await response.json()
  // console.log( result, "toplist/artist" )
  return result
}
export const getArtistsByCategory = async ( type, area ) => {
  // http://localhost:4000/artist/list?type=1&area=96&initial=m
  const response = await fetch( `${HOST}/artist/list?type=${type}&area=${area}`, { withCredentials: "include" } )
  const result = await response.json()
  // console.log( result, "artists by cat" )
  return result
}
export const addToFavorites = async ( songId ) => {
  const res = await axios( {
    url: `${HOST}/login/cellphone?phone=${phone}&password=${password}&timestamp=${timestamp}`,
    method: 'POST',
    withCredentials: "include" //essential
  } )
  cookieToken = res?.data.cookie
  const favoritedSong = axios( {
    url: `${HOST}/like/id=${songId}&cookie=${cookieToken}`,
    withCredentials: "include",
    method: 'POST',
  } )
    .then( function ( res ) {
      console.log( res.data, "res" )
      return res
    } )
    .catch( function ( error ) {
      console.log( error )
    } )
  return favoritedSong
}

/**Not used atm**/
// export const dailySignIn = async ( type = 1 ) => {
//   const res = await axios( {
//     method: 'POST',
//     url: `${HOST}/daily_signin?type=${type}`,
//     withCredentials: "include"
//   } )
//     .then( function ( res ) {
//       console.log( res.data, "daily sign-in res" )
//     } )
//     .catch( function ( error ) {
//       console.log( "Error daily sign-n: ", error )
//     } )
//   console.log( res, "daily sign-in--2" )
//   return res.data
// }
// export const checkLogin = async ( id ) => {
//   // &timestamp=${timestamp}
//   await axios( {
//     url: `${HOST}/login/status`,
//     withCredentials: "include",
//     method: 'POST'
//   } )
//     .then( function ( res ) {
//       // console.log( res, "checkLogin/simiUser--@api" )
//       if ( res.status === 301 ) {
//         const mssg = "Login Required!"
//         alert( mssg )
//         // throw new Error( mssg )
//       } else {
//         const simiUser = axios( {
//           method: 'POST',
//           url: `${HOST}/simi/user?id=${id}`,
//           withCredentials: "include"
//         } )
//           .then( function ( res ) {
//             console.log( res.data, "simi-user?" )
//             return res.data
//           } )
//         console.log( simiUser, "simi-user--2?" )
//         return simiUser
//       }
//     } )
//     .catch( function ( error ) {
//       console.log( error, "error" )
//     } )
// }

/**Other useful routes**/
// 电子 = electronic byTag
// top/list?id=2809577409 CloudNewSongs daily
// top/playlist?order=hot&cat=欧美&offset=0&limit=5 
// related/playlist?id=2098892084 
// detail?id=3029505227
// simi/song?id=1459387934
// user/record?uid=32953014&type=1
// `${HOST}/top/album?offset=0&limit=30&year=2020&month=6&area=EA`

// https://music.bluepill.one/api/toplist/artist?type=2
// https://tastedive.com/api/similar?q=apparat%2C+the+knife